import React, { memo, useState } from 'react';
import clsx from 'clsx';
import { Elements } from '@stripe/react-stripe-js';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

import { Typography, Button, makeStyles, IconButton } from '@material-ui/core';
import {
  SingleDialog,
  DialogContent,
  DialogHeader,
} from '../../../../CustomDialogs';
import { InfoOhoIcon } from '../../../../../constants';
import SelectPlanPopup from './SelectPlanPopup';

import { hasPermission } from '../../../../Utils/helper';

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: '32px',
    fontWeight: '600',
    lineHeight: '34px',
    color: '#000',
    textAlign: 'center',
  },
  header: {
    padding: '.5rem 1rem 0',
    '& .dialog__header__container': {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
    },
  },
  info__icon: {
    height: '80px',
    width: '80px',
    '& svg': {
      height: '100%',
      width: '100%',
    },
  },
  icon__padding: {
    padding: '5px',
  },
  main__popup: {
    width: '22rem',
    height: '21.5rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '98%',
      width: '98%',
    },
  },
  main__styles: {
    padding: '0 1rem 3rem',
    height: 'calc(100% - 52px)',
    overflow: 'auto',
    '& .dialog__content__inner': {
      height: '100%',
    },
  },
  control__height: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  para: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '500',
    color: '#263238',
    padding: '1rem 0 2rem',
    textAlign: 'center',
  },
  space__bw: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  main__btn: {
    borderRadius: '28px',
    fontSize: '13px',
    boxShadow: 'none',
    textTransform: 'capitalize',
    height: '40px',
    width: '47%',
  },
  export__btn: {
    background: 'var(--color-primary)',
    color: '#fff',
    border: '1px solid var(--color-primary)',
    '&:hover': {
      background: 'var(--color-primary)',
    },
  },
  contact__btn: {
    background: 'transparent !important',
    border: '1px solid var(--color-primary)',
    color: 'var(--color-primary)',
  },
  disabled__btn: {
    color: '#6d7d8b !important',
    background: '#ececee !important',
    '& svg': {
      '& path': {
        stroke: '#6d7d8b',
      },
    },
  },
}));
const WarningPopup = ({ toggle, setToggle, stripePromise }) => {
  const classes = useStyles();

  const [openSelectPlanPopup, setOpenSelectPlanPopup] = useState(false);

  const contactSupport = () => {
    // open embeded hubspot conversation
    window.HubSpotConversations?.widget?.open();
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/signin';
  };

  return (
    <>
      {toggle && (
        <SingleDialog
          styles={classes.main__popup}
          toggle={toggle}
          setToggle={setToggle}
        >
          <DialogHeader headerStyle={classes.header}>
            <IconButton
              className={clsx(classes.icon__padding, 'c-pointer')}
              onClick={handleLogout}
            >
              <CloseRoundedIcon />
            </IconButton>
          </DialogHeader>
          <DialogContent mainStyles={classes.main__styles}>
            <div className={classes.control__height}>
              <div className={classes.info__icon}>
                <InfoOhoIcon />
              </div>
              <Typography className={classes.heading}>Uh-oh!</Typography>
              <Typography className={classes.para}>
                It seems your account is inactive. Please update your payment
                details to continue using Torque360.
              </Typography>
              {hasPermission('settings', 'Subscription Settings') ? (
                <div className={clsx('d-flex w-100', classes.space__bw)}>
                  <Button
                    onClick={() => setOpenSelectPlanPopup(true)}
                    className={clsx(classes.main__btn, classes.export__btn)}
                  >
                    Update Payment
                  </Button>

                  <Button
                    onClick={contactSupport}
                    className={clsx(classes.main__btn, classes.contact__btn)}
                  >
                    Contact Support
                  </Button>
                </div>
              ) : (
                ''
              )}
            </div>
          </DialogContent>

          {openSelectPlanPopup && (
            <Elements stripe={stripePromise}>
              <SelectPlanPopup
                toggle={openSelectPlanPopup}
                setToggle={setOpenSelectPlanPopup}
              />
            </Elements>
          )}
        </SingleDialog>
      )}
    </>
  );
};
export default memo(WarningPopup);
